import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { OwnerEditRequestBody, OwnerEditResponse } from "./types";

export class OwnerEditAPI extends BaseAPI<
    OwnerEditRequestBody,
    OwnerEditResponse
> {
    protected route = ApiRoutes.owner.edit;
    protected method = RequestMethod.PUT;
    protected params = ['id'];
}
